// extracted by mini-css-extract-plugin
export default {"card":"GenericSelectCard_card__DgLTH","card_content":"GenericSelectCard_card_content__j9rsC"};